import type { ChatModelOption } from "@/lib/api";
import type { ChatEffort } from "@/lib/chat";

/** API が返すモデル一覧から重複 ID を除き、最初に返った順序を保つ。 */
export function dedupeChatModels(models: readonly ChatModelOption[]): ChatModelOption[] {
	return Array.from(new Map(models.map((model) => [model.id, model])).values());
}

/** モデル変更後も選択中の推論レベルを維持できるなら維持し、できなければ指定された既定値へ揃える。 */
export function resolveEffortForModel(
	model: ChatModelOption,
	currentEffort: ChatEffort | null,
	defaultEffort: ChatEffort,
): ChatEffort | null {
	if (model.supportedEfforts.length === 0) return null;
	if (currentEffort === null || !model.supportedEfforts.includes(currentEffort)) {
		return model.supportedEfforts.includes(defaultEffort)
			? defaultEffort
			: model.supportedEfforts[0];
	}
	return currentEffort;
}
